module.exports = __webpack_public_path__ + "img/t-2.da7e72f.png";